export function GradientBg() {
  return (
    <div className="bg-gradient-to-b from-green-50 absolute inset-0 h-screen -z-50" />
  );
}
